
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import BackofficeLayout from '@/components/layouts/BackofficeLayout';
import { UserList } from '@/components/users/UserList';

const Users = () => {
  return (
    <BackofficeLayout>
      <Card>
        <CardHeader>
          <CardTitle>Users Management</CardTitle>
        </CardHeader>
        <CardContent>
          <UserList />
        </CardContent>
      </Card>
    </BackofficeLayout>
  );
};

export default Users;
